import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Edit2, Trash2 } from "lucide-react";
import LoadingSpinner from "@/components/LoadingSpinner";

function SlotOcupado({ horario, loja, ocupacao, abrirModalEdicao, excluirAgendamento }) {
  const agendamento = { id: ocupacao.id, horario, loja, ...ocupacao };
  return (
    <div
      className="px-2 py-1 bg-slate-100 border border-slate-300 rounded cursor-pointer hover:bg-slate-200 transition-colors group"
      onClick={() => abrirModalEdicao(agendamento)}
      data-testid={`slot-ocupado-${horario}-${loja}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-xs font-medium text-slate-800 truncate">{ocupacao.nome || "Agendado"}</p>
          <div className="flex gap-1 text-[10px] text-slate-500">
            {ocupacao.idade && <span>{ocupacao.idade}a</span>}
            {ocupacao.telefone && <span>• {ocupacao.telefone}</span>}
          </div>
        </div>
        <div className="flex items-center gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
          <button
            onClick={(e) => { e.stopPropagation(); abrirModalEdicao(agendamento); }}
            className="p-0.5 hover:bg-slate-300 rounded"
          >
            <Edit2 className="w-3 h-3 text-slate-600" />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); excluirAgendamento(ocupacao.id); }}
            className="p-0.5 hover:bg-red-100 rounded"
          >
            <Trash2 className="w-3 h-3 text-red-500" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default function AgendaDiaView({
  diaSelecionado, horariosDia, loadingDia, lojas, formatarData,
  voltarParaCalendario, abrirModalNovoAgendamento, abrirModalEdicao, excluirAgendamento,
}) {
  return (
    <div className="space-y-6" data-testid="agenda-dia-container">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={voltarParaCalendario}
            data-testid="btn-voltar-calendario"
            className="hover:bg-slate-100"
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div>
            <h1 className="text-2xl font-bold text-slate-900 capitalize">{formatarData(diaSelecionado)}</h1>
            <p className="text-sm text-slate-500">Selecione um horário disponível para agendar</p>
          </div>
        </div>
      </div>

      <Card className="bg-white border border-slate-200 shadow-sm">
        <CardContent className="p-0">
          {loadingDia ? (
            <div className="py-12">
              <LoadingSpinner message="Carregando horarios..." />
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full" data-testid="tabela-horarios">
                <thead>
                  <tr className="border-b border-slate-200 bg-slate-50">
                    <th className="px-2 py-1.5 text-left text-[10px] font-semibold text-slate-600 uppercase tracking-wider w-14">Hora</th>
                    {lojas.map((loja) => (
                      <th key={loja} className="px-2 py-1.5 text-left text-[10px] font-semibold text-slate-600 uppercase tracking-wider min-w-[140px]">
                        {loja}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {horariosDia.map((item, index) => (
                    <tr
                      key={item.horario}
                      className={`hover:bg-slate-50 transition-colors ${index % 2 === 0 ? "bg-white" : "bg-slate-50/30"}`}
                      data-testid={`row-${item.horario}`}
                    >
                      <td className="px-2 py-1">
                        <span className="font-mono text-xs font-medium text-slate-600">{item.horario}</span>
                      </td>
                      {lojas.map((loja) => {
                        const ocupacao = item.ocupacao_por_loja[loja];
                        return (
                          <td key={loja} className="px-1 py-0.5">
                            {ocupacao?.ocupado ? (
                              <SlotOcupado
                                horario={item.horario}
                                loja={loja}
                                ocupacao={ocupacao}
                                abrirModalEdicao={abrirModalEdicao}
                                excluirAgendamento={excluirAgendamento}
                              />
                            ) : (
                              <button
                                onClick={() => abrirModalNovoAgendamento(item.horario, loja)}
                                className="w-full py-1 px-2 border border-dashed border-slate-300 rounded text-slate-400 hover:border-emerald-400 hover:bg-emerald-50 hover:text-emerald-600 transition-all"
                                data-testid={`slot-livre-${item.horario}-${loja}`}
                              >
                                <span className="text-[10px]">Livre</span>
                              </button>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
